import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=2925ceca&"
import script from "./FormDialog.vue?vue&type=script&lang=js&"
export * from "./FormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2925ceca')) {
      api.createRecord('2925ceca', component.options)
    } else {
      api.reload('2925ceca', component.options)
    }
    module.hot.accept("./FormDialog.vue?vue&type=template&id=2925ceca&", function () {
      api.rerender('2925ceca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/infoCategories/form-dialog/FormDialog.vue"
export default component.exports